import React from "react"
import ReactDOM from "react-dom"
import Accordion from "./accordion"

import * as htmlHelper from "../../helpers/html"

export default class AccordionModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.accordions = [...elem.querySelectorAll(".accordion")]
    self.init()
    return self
  }

  init() {
    const self = this
    if (self.elem.accordions?.length > 0) {
      self.elem.accordions.map((elem) => {
        ReactDOM.render(<Accordion className="accordion">{htmlHelper.domElementToReactElement(elem)}</Accordion>, elem)
      })
    }
  }
}
